import React from 'react';
import Reflux from 'reflux';
import Alert from 'bootstrap/Alert';
import ToastStore from 'flux/stores/ToastStore';
import { Icon } from '@shoflo-rundown/polymer.legacy';

/**
 * Generic toast list
 *
 */
export default React.createClass({
  mixins: [Reflux.connect(ToastStore, 'toast')],

  propTypes: {},

  displayName: 'ToastList',

  render() {
    if (this.state.toast.size <= 0) return null;

    return this._getAlertListNode();
  },

  _getAlertListNode() {
    let listNodes = this.state.toast.map((toast, id) => {
      let bsStyle = 'default';
      if (toast.type === 'success') bsStyle = 'success';
      if (toast.type === 'copied') bsStyle = 'success';
      if (toast.type === 'failure') bsStyle = 'danger';

      if (toast.type === 'copied') {
        return (
          <Alert bsStyle={bsStyle} key={'toast-' + id} className="toast-copied">
            {this._getToastContentNode(toast)}
          </Alert>
        );
      }

      return (
        <Alert bsStyle={bsStyle} key={'toast-' + id}>
          {this._getToastContentNode(toast)}
        </Alert>
      );
    });

    return <div className="toast-list">{listNodes}</div>;
  },

  _getToastContentNode(toast) {
    if (toast.content === ':bolt:') {
      return <Icon name="bolt" />;
    }

    return toast.content;
  },
});
